import { render, staticRenderFns } from "./LazyEmployeesTree.vue?vue&type=template&id=22ffbc86&scoped=true"
import script from "./LazyEmployeesTree.vue?vue&type=script&lang=js"
export * from "./LazyEmployeesTree.vue?vue&type=script&lang=js"
import style0 from "./LazyEmployeesTree.vue?vue&type=style&index=0&id=22ffbc86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ffbc86",
  null
  
)

export default component.exports